<template>

    <div class="row h-100">
        <div class="col-sm-10 col-md-11 col-lg-8 my-auto mx-auto">
            <div class="row">
                <div class="col-md-6 bg-white py-5 px-5">
                    <div class="row">
                        <div class="col-12 px-5 px-md-2">

                            <h1 class="text-center mb-3">
                                <span>Forgot Password</span>
                            </h1>

                            <!-- Success Message -->
                            <div v-if="submitted" class="alert alert-success text-center">
                                <h5>Reset Link Sent!</h5>
                                <p class="mb-0">If an account exists with that email address, you will receive a password reset link shortly.</p>
                                <router-link to="/login" class="btn btn-outline-primary mt-3">Back to Login</router-link>
                            </div>

                            <template v-else>
                                <kt-input
                                    class="my-2"
                                    v-model="email"
                                    label="Email"
                                    type="email"
                                    placeholder="Enter your email"
                                    required
                                >
                                    <template #prefix>
                                        <div class="input-group-text">
                                        <i class="fas fa-envelope"></i>
                                        </div>
                                    </template>
                            
                                </kt-input>

                                <kt-input
                                    class="my-2"
                                    v-model="domain"
                                    label="Domain (Optional)"
                                    type="text"
                                    placeholder="yourcompany (leave blank for main site)"
                                >
                                    <template #prefix>
                                        <div class="input-group-text">
                                        <i class="fas fa-globe"></i>
                                        </div>
                                    </template>
                            
                                </kt-input>
                                <small class="text-muted d-block mb-2">Enter your company subdomain if you have one</small>

                                <div class="text-center">
                                    <button 
                                        class="btn btn-outline-primary mt-4 py-2 px-4 form-control" 
                                        @click="submit()"
                                        :disabled="isSubmitting"
                                    >
                                        <span v-if="isSubmitting">Sending...</span>
                                        <span v-else>Send Reset Link</span>
                                    </button>
                                </div>

                                <div class="text-center my-2">
                                    <span class="text-muted"> &lt; Back to
                                        <router-link to="/login" class="text-muted">Login</router-link>
                                    </span>
                                </div>
                            </template>
                        </div>
                    
                    </div>
                </div>
                <div class="col-md-6 bg-login p-0">
                    <div class="bg h-100 d-flex py-3">
                        <div class="text-center my-auto text-white w-50 mx-auto">
                            <h4>
                                <img src="/favicon.svg" alt="7th Level Technologies" style="width: 25%; max-width: 100%; height: auto;" class="mb-3"><br />
                                Manage project time and resources with ease.
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>

import { ref } from "vue";
import { useRouter } from "vue-router";
import Api from "@/services/ApiService";
import Alert from "@/services/Alert";
import KtInput from "@/components/UI/KtInput.vue"; 

const email = ref("");
const domain = ref("");
const router = useRouter();
const isSubmitting = ref(false);
const submitted = ref(false);

const submit = async () =>
{
    // Validate required fields
    if (!email.value)
    {
        Alert.notify({
            text: "Please enter your email address"
        });
        return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.value))
    {
        Alert.notify({
            text: "Please enter a valid email address"
        });
        return;
    }

    isSubmitting.value = true;

    try {
        const res = await Api.forgotPassword({
            email: email.value,
            domain: domain.value.toLowerCase() || undefined
        });
        
        console.debug("forgot password response", res);

        // Always show success message to prevent email enumeration
        submitted.value = true;
    }
    catch (error) {
        console.error("Forgot password error:", error);
        // Still show success to prevent email enumeration
        submitted.value = true;
    }
    finally {
        isSubmitting.value = false;
    }
}

</script>

<style>

#app.forgot-password {
    background: #212121;
}

.bg-login {
    background-image: url("/images/login_bg.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    
}

.bg-login > .bg {
    background: linear-gradient(180deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.74) 50%, rgba(0, 0, 0, 1) 100%);
}
</style>